const filteredTables = document.querySelectorAll(".filtered-container");

if (filteredTables.length > 0) {
  console.log('dsfsd');
  
  filteredTables.forEach(container => {
    const table = container.querySelector('table');
    const select = container.querySelector('select');

    if (!table && !select) return;
    
    select.addEventListener("change", function () {
      const index = Array.from(table.querySelectorAll("thead th")).findIndex(th => th.textContent.trim().toLowerCase() === this.value.toLowerCase());
      const rows = table.querySelectorAll("tbody tr")

      if (!index && rows.length <= 0) return;

      rows.forEach(row => {
        if (this.value === "all") {
          row.classList.remove("hidden");
          return;
        }
        const cell = row.cells[index];

        (cell && cell.textContent.includes("✅")) ? row.classList.remove("hidden") : row.classList.add("hidden");
      });
    });
  });
};